import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import NavigateBefore from '@mui/icons-material/NavigateBefore';
import NavigateNext from '@mui/icons-material/NavigateNext';
import { LoadMorePeriodType } from '../smartDiaryNotes/hooks';
import { useTimesheetPeriodNavigatorActions } from './hooks';
import {
  useStyles,
  usePreviousNavigationStyles,
  useNextNavigationStyles
} from './useTimesheetPeriodNavigatorStyles';

type TimesheetPeriodNavigatorProps = {
  loadMorePeriods: LoadMorePeriodType;
};

export const TimesheetPeriodNavigator: React.FC<TimesheetPeriodNavigatorProps> = React.memo(
  ({ loadMorePeriods }: TimesheetPeriodNavigatorProps) => {
    const {
      handlePreviousClick,
      handleNextClick,
      timesheetPeriodString,
      disablePrevious,
      disableNext
    } = useTimesheetPeriodNavigatorActions(loadMorePeriods);

    const classes = useStyles();
    const previousNavigationStyles = usePreviousNavigationStyles({
      disablePrevious
    });
    const nextNavigationStyles = useNextNavigationStyles({ disableNext });

    return (
      <Box className={classes.root} data-testid="timesheet-period-selector">
        <IconButton
          size="small"
          disabled={disablePrevious}
          onClick={handlePreviousClick}
          data-testid="timesheet-period-previous"
        >
          <NavigateBefore classes={previousNavigationStyles} />
        </IconButton>
        <IconButton
          size="small"
          disabled={disableNext}
          onClick={handleNextClick}
          data-testid="timesheet-period-next"
        >
          <NavigateNext classes={nextNavigationStyles} />
        </IconButton>
        <Typography
          className={classes.period}
          data-testid="timesheet-period-text"
        >
          {timesheetPeriodString}
        </Typography>
      </Box>
    );
  }
);

TimesheetPeriodNavigator.displayName = 'TimesheetPeriodNavigator';
